import * as Types from '../../../@types/graphql-types';

import { PopularTitleGraphqlFragment } from '../fragments/PopularTitle.fragment';
import gql from 'graphql-tag';
import { PopularTitleGraphqlFragmentDoc } from '../fragments/PopularTitle.fragment';
export type GetPopularTitlesQueryVariables = Types.Exact<{
	country: Types.Scalars['Country'];
	popularTitlesFilter?: Types.Maybe<Types.TitleFilter>;
	watchNowFilter: Types.WatchNowOfferFilter;
	popularAfterCursor?: Types.Maybe<Types.Scalars['String']>;
	popularTitlesSortBy?: Types.PopularTitlesSorting;
	first?: Types.Scalars['Int'];
	language: Types.Scalars['Language'];
	platform?: Types.Platform;
	sortRandomSeed?: Types.Scalars['Int'];
	profile?: Types.Maybe<Types.PosterProfile>;
	backdropProfile?: Types.Maybe<Types.BackdropProfile>;
	format?: Types.Maybe<Types.ImageFormat>;
}>;

export type GetPopularTitlesQuery = { __typename?: 'Query' } & {
	popularTitles: { __typename?: 'PopularTitlesConnection' } & Pick<Types.PopularTitlesConnection, 'totalCount'> & {
			pageInfo: { __typename?: 'PageInfo' } & Pick<
				Types.PageInfo,
				'startCursor' | 'endCursor' | 'hasPreviousPage' | 'hasNextPage'
			>;
			edges?: Types.Maybe<Array<{ __typename?: 'PopularTitlesEdge' } & PopularTitleGraphqlFragment>>;
		};
};

export const GetPopularTitlesDocument = gql`
	query GetPopularTitles(
		$country: Country!
		$popularTitlesFilter: TitleFilter
		$watchNowFilter: WatchNowOfferFilter!
		$popularAfterCursor: String
		$popularTitlesSortBy: PopularTitlesSorting! = POPULAR
		$first: Int! = 40
		$language: Language!
		$platform: Platform! = WEB
		$sortRandomSeed: Int! = 0
		$profile: PosterProfile
		$backdropProfile: BackdropProfile
		$format: ImageFormat
	) {
		popularTitles(
			country: $country
			filter: $popularTitlesFilter
			after: $popularAfterCursor
			sortBy: $popularTitlesSortBy
			first: $first
			sortRandomSeed: $sortRandomSeed
		) {
			totalCount
			pageInfo {
				startCursor
				endCursor
				hasPreviousPage
				hasNextPage
			}
			edges {
				...PopularTitleGraphql
			}
		}
	}
	${PopularTitleGraphqlFragmentDoc}
`;
